var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilterIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 10,
  fill: "none",
  viewBox: "0 0 18 10",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.625 5a.625.625 0 0 1-.625.625H4a.625.625 0 0 1 0-1.25h10a.625.625 0 0 1 .625.625m2.5-4.375H.875a.625.625 0 0 0 0 1.25h16.25a.625.625 0 1 0 0-1.25m-6.25 7.5h-3.75a.625.625 0 0 0 0 1.25h3.75a.625.625 0 1 0 0-1.25"
})));
export { SvgFilterIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/filterIcon.svg";